module.exports = __webpack_public_path__ + "uy.6afe5efa.svg";